import { masterConfig } from "../configs/generalConfig";

/**
 * Every field a Timekeeper record carries: the year's start-page fields (who, which
 * match, which robot), the timestamps, and how they were taken.
 *
 * Timekeeper copies the start-page fields from the scout's match data, but only those
 * present there. Without filling the rest, two records could differ in their fields, and
 * the Pi files each shape in its own table - the same split auto_field caused.
 */
export function timekeeperFields(settingsYear) {
    const config = masterConfig[settingsYear] || {};
    return [...new Set([
        ...Object.keys(config.startScoutPage || {}),
        ...Object.keys(config.initialPage || {}),
        "auto_timestamps",
        "timekeeping_type",
    ])];
}

/**
 * The record with every Timekeeper field present. Missing timestamps are an empty list
 * (the same type as recorded ones); anything else missing is blank, which the Pi treats
 * as "no value" rather than as a type. Existing values are never changed.
 */
export function completeTimekeeperRecord(map, settingsYear) {
    const full = new Map(map);
    for (const field of timekeeperFields(settingsYear)) {
        if (!full.has(field)) full.set(field, field === "auto_timestamps" ? [] : "");
    }
    return full;
}
